import {
  CircularProgressWrapper,
  StyledCircularProgress,
  StyledCircularProgressBackground,
} from './CircularLoading.styles'

export type CircularLoadingSize = 'small' | 'large'

type CircularLoadingProps = {
  size?: CircularLoadingSize
}

export const CircularLoading = ({
  size = 'large',
}: CircularLoadingProps): JSX.Element => {
  const loaderSize = size === 'large' ? 64 : 24

  return (
    <CircularProgressWrapper
      data-testid="div_circular_loading"
      size={size}
      loaderSize={loaderSize}
    >
      <StyledCircularProgressBackground
        variant="determinate"
        size={loaderSize}
        thickness={3}
        value={100}
        title="circle-loading"
      />
      <StyledCircularProgress
        variant="indeterminate"
        disableShrink
        size={loaderSize}
        thickness={3}
      />
    </CircularProgressWrapper>
  )
}
